export const getClaimsStart = () => ({
	type: "GET_CLAIMS_START",
});

export const getClaimsSuccess = (claims) => ({
	type: "GET_CLAIMS_SUCCESS",
	payload: claims
});

export const getClaimsFailure = () => ({
	type: "GET_CLAIMS_FAILURE",
});

export const getClaimStart = () => ({
	type: "GET_CLAIM_START",
});

export const getClaimSuccess = (claims) => ({
	type: "GET_CLAIM_SUCCESS",
	payload: claims
});

export const getClaimFailure = () => ({
	type: "GET_CLAIM_FAILURE",
});

export const createClaimStart = () => ({
	type: "CREATE_CLAIM_START",
});

export const createClaimSuccess = (claim) => ({
	type: "CREATE_CLAIM_SUCCESS",
	payload: claim
});

export const createClaimFailure = () => ({
	type: "CREATE_CLAIM_FAILURE",
});